import axios from "axios";

export function getJson(url, params = {}) {
  const options = {
    method: "GET",
    url,
    headers: { 'Content-Type': 'application/json' },
    // headers: {
    //   "Content-Type": "application/json",
    //   "Access-Control-Allow-Origin": "*",
    //   "Access-Control-Allow-Headers": "X-Custom-Information",
    //   "Access-Control-Allow-Methods": "GET, HEAD, OPTIONS",
    //   "Access-Control-Allow-Credentials": "true",
    // },
    params
  };

  return axios(options);
}


// WEBPACK FOOTER //
// ./src/libs/request.jsx